import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default propTypes;
